module.exports = __webpack_public_path__ + "static/media/logo-short.7fbb254c.svg";